import { FC } from 'react';
import { styled, Typography } from '@material-ui/core';
import { SPACING_LARGE } from '../../../constant/spacing';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

// https://www.figma.com/file/oy0lqfg1RnOZ1Y7129AJmc/KAIZEN-Design-Library?node-id=40%3A11173
const StyledTypography = styled(Typography)({
  fontWeight: 700,
  fontSize: '24px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '105%',
  marginTop: SPACING_LARGE,
  marginBottom: SPACING_LARGE,
  textAlign: 'start',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
  '&.Kz-flexGrow': {
    flexGrow: 1,
  },
});

type Props = {
  children: React.ReactNode | Array<React.ReactNode>;
  flexGrow?: boolean;
  [x: string]: any;
};

const PageTitle: FC<Props> = ({ children, flexGrow, ...props }) => {
  const { className: _className } = props;
  const className = `${flexGrow ? 'Kz-flexGrow ' : ''}${_className}`;
  return (
    <StyledTypography {...props} className={className}>
      {children}
    </StyledTypography>
  );
};

export const PageTitleStyle = {
  fontWeight: 700,
  fontSize: '24px',
  fontStyle: 'normal',
  color: COLOR_TEXT_MAIN,
  lineHeight: '105%',
  '&.Mui-focused': {
    color: COLOR_TEXT_MAIN,
  },
  '&.Kz-flexGrow': {
    flexGrow: 1,
  },
};

export default PageTitle;
